enum CertifiableAddressType {
    Customer = 'Customer',
    AlternatePayee = 'AlternatePayee',
}

export default CertifiableAddressType;
